const getMsgReviews = ({ numberComments, numberReviews }: any) => {
  if (numberReviews == 1 && numberComments == 0) {
    return `${numberReviews} nota, sem nenhum comentário`;
  }
  if (numberReviews == 1 && numberComments == 1) {
    return `${numberReviews} nota, com 1 comentário`;
  }
  if (numberReviews > 1 && numberComments == 0) {
    return `${numberReviews} notas, sem nenhum comentário`;
  }
  if (numberReviews > 1 && numberComments == 1) {
    return `${numberReviews} notas, com 1 comentário`;
  }

  return `${numberReviews} notas, com ${numberComments} comentários`;
};

export default getMsgReviews;
export { getMsgReviews };
